import { resources } from "@constants/hardcoded-strings";
import { MESSAGING_TEMPLATES_DETAILS_URL } from "@constants/routes";
import { MESSAGING_TEMPLATE_ID_PATTERN } from "@constants/url-parameter-patterns";
import { TableCellWithDropdown } from "@containers/common/table-cell-with-dropdown/table-cell-with-dropdown";
import { FormattedMessagingTemplateConfiguration } from "@idw-types/data/messaging-template";
import { navigateToUtil } from "@utils/navigation-util";
import { injectCustomIdParameter } from "@utils/parameter-injector";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

type MessagingTemplateCellProps = {
    value: string;
    messagingTemplate: FormattedMessagingTemplateConfiguration;
}

export const MessagingTemplatesCell = (props: MessagingTemplateCellProps) => {
    const { value, messagingTemplate } = props;
    const routerLocation = useLocation();
    const navigate = useNavigate();

    const onClickRedirectToDetails = () => {
        const url = injectCustomIdParameter(MESSAGING_TEMPLATES_DETAILS_URL, messagingTemplate.id, MESSAGING_TEMPLATE_ID_PATTERN);
        navigateToUtil(url, navigate, routerLocation.pathname);
    }

    const dropdownItems = useMemo(() => {
        const prefix = 'messaging-template-table-dropdown-item';
        const items = [];

        if (messagingTemplate.permissions.canView) {
            items.push({
                idSuffix: `${prefix}-open`,
                title: resources.tables.messagingTemplates.dropdownItems.openDetails.label,
                text: resources.tables.messagingTemplates.dropdownItems.openDetails.label,
                onClick: onClickRedirectToDetails
            });
        }

        return items;

    }, []);

    return (<TableCellWithDropdown
        value={value}
        dropdownText={""}
        items={dropdownItems}
        uniqueId={messagingTemplate.id}
    />);
}